module.exports = require("@bechtel/client-assets/dist/images/empty-state-weld-dashboard.svg");